import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type PayoutMethodRoutingData = {
  listingIds: number[];
};

const getPayoutMethodRouting =
  (makeCall: MakeCall) => (userId: number, payoutMethodId: string) =>
    makeCall<PayoutMethodRoutingData>(
      'GET',
      `/v1/user/${userId}/payout-routing/link/${payoutMethodId}`,
    );

export default getPayoutMethodRouting;
